import React from 'react';
import TickerTape from '../components/layout/TickerTape';
import HeroSection from '../components/hero/HeroSection';
import AdvertisementSection from '../components/advertisement/AdvertisementSection';
import FeaturedIssues from '../components/featured/FeaturedIssues';
import GmpSection from '../components/gmp/GmpSection';
import FilingsDirectory from '../components/filings/FilingsDirectory';
import SubscriptionDemand from '../components/subscription/SubscriptionDemand';
import NewsSection from '../components/news/NewsSection';

export const LandingPage = () => {
  return (
    <>
      {/* Real-time Market Ticker Tape */}
      <TickerTape />

      {/* Main Content Sections */}
      <main className="flex-1">
        {/* Hero Section with Live Terminal Display */}
        <HeroSection />

        {/* Home leaderboard ad (GET /api/ads -> 'leaderboard') */}
        <AdvertisementSection slotId="leaderboard" />

        {/* Featured Issues (Mainboard & SME Carousel) */}
        <FeaturedIssues />

        {/* Home in-feed ad between IPO lists (GET /api/ads -> 'infeed') */}
        <AdvertisementSection
          slotId="infeed"
          variant="feature"
          maxWidthClass="max-w-[960px]"
          className="pt-2 pb-12 sm:pb-16 bg-white"
        />

        {/* Grey Market Premium Tracker (GET /api/market/gmp) */}
        <GmpSection />

        {/* DRHP Filings & Pipeline Directory Table */}
        <FilingsDirectory />



        {/* Live Subscription Demand Tracker */}
        <SubscriptionDemand />

        {/* IPO News & Market Updates */}
        <NewsSection />
      </main>
    </>
  );
};

export default LandingPage;
